export const theme = {
  colors: {
    primary: '#00D0C0',
    primaryDark: '#00B3A6',
    background: '#0a0a0f',
    backgroundDark: '#050508',
    backgroundLight: '#16161f',
    text: '#FFFFFF',
    textSecondary: '#9ca3af',
    textMuted: '#6b7280',
    accent: '#a855f7',
    accentSecondary: '#6366f1',
    error: '#ef4444',
    green: '#10b981',
    success: '#22c55e',
    border: 'rgba(255,255,255,0.08)',
    yellow: '#fbbf24',
    gold: '#f59e0b',
    goldLight: '#fcd34d',
    // Glass effect colors
    glass: 'rgba(255, 255, 255, 0.03)',
    glassBorder: 'rgba(255, 255, 255, 0.08)',
    glassHover: 'rgba(255, 255, 255, 0.06)',
  },
  gradients: {
    primary: 'linear-gradient(135deg, #00D0C0 0%, #6366f1 50%, #a855f7 100%)',
    primarySubtle: 'linear-gradient(135deg, rgba(0,208,192,0.1) 0%, rgba(99,102,241,0.1) 100%)',
    gold: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 50%, #d97706 100%)',
    goldSubtle: 'linear-gradient(135deg, rgba(251,191,36,0.15) 0%, rgba(245,158,11,0.05) 100%)',
    purple: 'linear-gradient(135deg, #a855f7 0%, #6366f1 100%)',
    success: 'linear-gradient(135deg, #10b981 0%, #22c55e 100%)',
    cardBorder: 'linear-gradient(135deg, rgba(0,208,192,0.3) 0%, rgba(99,102,241,0.3) 50%, rgba(168,85,247,0.3) 100%)',
    glow: 'radial-gradient(circle, rgba(0,208,192,0.15) 0%, transparent 70%)',
    mesh: 'radial-gradient(at 40% 20%, rgba(99,102,241,0.15) 0px, transparent 50%), radial-gradient(at 80% 0%, rgba(168,85,247,0.1) 0px, transparent 50%), radial-gradient(at 0% 50%, rgba(0,208,192,0.1) 0px, transparent 50%)',
  },
  shadows: {
    neon: '0 0 20px rgba(0,208,192,0.3), 0 0 40px rgba(99,102,241,0.2)',
    neonGold: '0 0 20px rgba(251,191,36,0.4), 0 0 40px rgba(245,158,11,0.2)',
    box: '0 4px 24px rgba(0,0,0,0.4)',
    card: '0 8px 32px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.05)',
    cardHover: '0 16px 48px rgba(0,0,0,0.5), 0 0 0 1px rgba(0,208,192,0.2)',
    glow: '0 0 60px rgba(0,208,192,0.2)',
  },
  fonts: {
    primary: '"Orbitron", sans-serif',
    secondary: '"Rajdhani", sans-serif',
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '16px',
    xlarge: '24px',
    circle: '50%',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
  transitions: {
    fast: '0.2s ease',
    medium: '0.3s ease',
    slow: '0.5s ease',
  },
};
